import { cssTransition } from 'react-toastify';

export const FadeInDown = cssTransition({
    enter: 'animate__animated animate__faster animate__fadeInDown',
    exit: 'animate__animated animate__faster animate__fadeOutUp',
});
